<ng-container *ngIf="product$ | async as product">
  <div *ngIf="!product.failed" class="product-tile" [attr.data-testing-sku]="product.sku">
    <div class="product-image-container icsa-image-container">
      <div
        *ngFor="let view of getImagesViews(product); let i = index"
        class="{{ i === 0 ? 'primary-image' : 'secondary-image' }} product-img-wrapp"
      >
        <ish-product-image imageType="M" [imageView]="view" [link]="true"></ish-product-image>
      </div>
      <ish-product-label></ish-product-label>
      <!-- DIAS Customization - Marketing Bug -->
      <custom-product-marketing-label></custom-product-marketing-label>
    </div>

    <div class="product-tile-home">
      <span class="product-tile-name">
        <ish-product-name></ish-product-name>
      </span>
      <span class="float-right product-tile-buttons">
        <ish-lazy-product-add-to-order-template [cssClass]="'btn btn-link mr-0'" displayType="icon">
        </ish-lazy-product-add-to-order-template>
        <ish-lazy-product-add-to-wishlist cssClass="btn-link" displayType="icon"></ish-lazy-product-add-to-wishlist>
        <ish-lazy-product-add-to-compare displayType="icon" cssClass="btn-link"></ish-lazy-product-add-to-compare>
        <a *ishFeature="'quickView'" [routerLink]="[]" (click)="openQuickView(product.sku)">
          <div>
            <!-- <fa-icon [icon]="['fas', 'balance-scale']"></fa-icon> -->
            <button
              class="btn add-to-compare rounded-circle btn-link"
              title="{{ 'product.quick_view.link' | translate }}"
            >
              <!-- <fa-icon [icon]="['fas', 'balance-scale']"></fa-icon> -->
              <i class="icon-eye"></i>
            </button>
          </div>
        </a>
      </span>
    </div>

    <div
      class="price-adjustment-in-tab position-relative overflow-hidden"
      [ngClass]="{ 'pt-1': !isMasterProduct, 'pb-3': !isMasterProduct }"
    >
      <div *ngIf="configuration$('price') | async" [ngClass]="{ 'price-container': !isMasterProduct }">
        <ish-product-price [showInformationalPrice]="true"></ish-product-price>
      </div>
      <ish-product-add-to-basket displayType="plaintext" cssClass="add-to-cart btn-link"> </ish-product-add-to-basket>
    </div>

    <ish-product-item-variations [showVisible]="false"></ish-product-item-variations>
  </div>
</ng-container>
